/**
 * El indicador de conexión.  (FR-014, T050)
 *
 * De las poquísimas piezas que la spec llama "el peor fallo posible". Su trabajo
 * es NO MENTIR: distinguir a simple vista tres cosas que se confunden fácil:
 *
 *   · en-vivo       → verde. Datos frescos, socket sano.
 *   · sondeo-caido  → ámbar. Socket VIVO pero el dato está congelado (el sondeo
 *                     murió). El caso que un socket solo jamás detectaría.
 *   · desconectado  → rojo. La API no responde; reconectando.
 *
 * (shadcn/ui no trae un indicador de conexión: se escribe a mano, y el Principio
 * IV lo permite — "no reinventar primitivos" no es "no escribir nada".)
 */
import type { EstadoConexion } from '../lib/conexion'
import { cn } from '../lib/cn'

const ASPECTO: Record<EstadoConexion, { punto: string; texto: string; etiqueta: string; pulso: boolean }> = {
    'en-vivo': { punto: 'bg-emerald-500', texto: 'text-emerald-400', etiqueta: 'En vivo', pulso: true },
    conectando: { punto: 'bg-neutral-500', texto: 'text-neutral-400', etiqueta: 'Conectando…', pulso: true },
    'sondeo-caido': { punto: 'bg-amber-500', texto: 'text-amber-400', etiqueta: 'Sondeo caído · datos congelados', pulso: false },
    desconectado: { punto: 'bg-red-500', texto: 'text-red-400', etiqueta: 'Desconectado', pulso: false },
}

export function ConnectionIndicator({ estado }: { estado: EstadoConexion }) {
    const a = ASPECTO[estado]
    return (
        <span
            data-testid="indicador-conexion"
            data-estado={estado}
            className={cn('inline-flex items-center gap-2 text-xs font-medium', a.texto)}
            title={a.etiqueta}
        >
            <span className="relative flex h-2 w-2">
                {a.pulso && (
                    <span className={cn('absolute inline-flex h-full w-full animate-ping rounded-full opacity-60', a.punto)} />
                )}
                <span className={cn('relative inline-flex h-2 w-2 rounded-full', a.punto)} />
            </span>
            {a.etiqueta}
        </span>
    )
}
